import "../../../../content/projects/offschool/offschool.css";
import * as React from 'react';
export default {
  React
};